<ng-container *ngIf="customAppName">
    <div class="eui-header-app__title full">
        <ng-content select="eui-header-app-name"></ng-content>
    </div>
</ng-container>
<ng-container *ngIf="!customAppName">
    <div *ngIf="appNameFromState" class="eui-header-app__title full">
        {{appNameFromState}}
    </div>
</ng-container>

<div class="eui-header-app__title short">
    {{appShortNameFromState}}
</div>

<ng-container *ngIf="customAppSubtitle">
    <div class="eui-header-app__sub-title">
        <ng-content select="eui-header-app-subtitle"></ng-content>
    </div>
</ng-container>
<ng-container *ngIf="!customAppSubtitle">
    <div *ngIf="appSubTitleFromState" class="eui-header-app__sub-title">{{appSubTitleFromState}}</div>
</ng-container>
